import { useState } from "react";
import { ChevronDown } from "lucide-react";

/**
 * Expandable panel component for Covenant Transparency sections
 * Motion is slow, intentional, and restrained
 */
export function CovenantPanel({ 
  title, 
  scripture,
  reference,
  children,
  defaultOpen = false,
  icon: Icon,
  stepNumber
}) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className={`border bg-white overflow-hidden transition-all duration-500 ${
      isOpen ? "border-[#BFA15F]/40 shadow-md" : "border-[#E7E5E4] hover:border-[#BFA15F]/30"
    }`}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-[#BFA15F] focus-visible:ring-offset-2 transition-colors duration-300"
        aria-expanded={isOpen}
      >
        <div className="flex items-center gap-4">
          {stepNumber && (
            <div className={`w-8 h-8 flex items-center justify-center text-sm font-medium transition-all duration-300 ${
              isOpen ? "bg-[#BFA15F] text-white" : "bg-[#F5F5F4] text-[#57534E]"
            }`}>
              {stepNumber}
            </div>
          )}
          {Icon && !stepNumber && (
            <div className={`w-10 h-10 flex items-center justify-center flex-shrink-0 transition-all duration-300 ${
              isOpen ? "bg-[#BFA15F]/10" : "bg-[#F5F5F4]"
            }`}>
              <Icon className={`w-5 h-5 transition-colors duration-300 ${isOpen ? "text-[#BFA15F]" : "text-[#57534E]"}`} />
            </div>
          )}
          <div>
            <h3 className="font-serif text-lg text-[#1C1917] font-medium">{title}</h3>
            {scripture && (
              <p className={`text-sm mt-1 italic transition-opacity duration-300 ${isOpen ? "text-[#BFA15F]" : "text-[#A8A29E]"}`}>
                "{scripture}" — {reference}
              </p>
            )}
          </div>
        </div>
        <ChevronDown 
          className={`w-5 h-5 text-[#57534E] transition-transform duration-500 flex-shrink-0 ${isOpen ? "rotate-180" : ""}`}
          aria-hidden="true"
        />
      </button>
      
      <div 
        className={`transition-all duration-500 ease-out ${isOpen ? "max-h-[600px] opacity-100" : "max-h-0 opacity-0"}`}
        style={{ overflow: "hidden" }}
      >
        <div className="px-6 pb-6 pt-2 border-t border-[#E7E5E4]">
          <div className={`${stepNumber ? "pl-12" : "pl-14"} text-[#57534E] space-y-4`}>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}

export default CovenantPanel;
